import INVOICE_DEVOLUTION from '../../data/invoiceDevolution';
import RestService from '../services/rest';

async function getSphereMotivosList(devolutionReasonType) {
  return RestService.getAuthenticated(
    `invoice/devolution/sphere/motivos?reason=${devolutionReasonType}`,
  );
}

async function getClientContactEmailsList(clientId) {
  return RestService.getAuthenticated(
    `invoice/devolution/client/contact/emails?clientId=${clientId}`,
  );
}

async function getInvoiceDevolutionList({ clientId }, filterBy) {
  let url = `invoice/devolution/list?clientId=${clientId}`;
  if (filterBy !== INVOICE_DEVOLUTION.types[0].label) url += `&status=${filterBy}`;
  return RestService.getAuthenticated(url);
}

async function getInvoiceDevolutionDetails(nciNumber, devolutionNumber) {
  return RestService.getAuthenticated(
    `invoice/devolution/details?nciNumber=${nciNumber}&devolutionNumber=${devolutionNumber}`,
  );
}

async function uploadInvoiceDevolutionFile(file, name) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated(
    `invoice/devolution/import/file?name=${name}`,
    fd,
    { 'Content-Type': 'multipart/form-data' },
  );
}

async function deleteInvoiceDevolutionFile(file) {
  return RestService.postAuthenticated(
    `invoice/devolution/delete/file?fileName=${file}`,
  );
}

async function sendInvoiceDevolutionSolicitation(solicitation) {
  return RestService.postAuthenticated(
    'invoice/devolution/send',
    { solicitation },
  );
}

async function createInvoiceDevolutionSolicitation(solicitation, sphereId) {
  return RestService.postAuthenticated(
    `invoice/devolution/create?sphereId=${sphereId}`,
    { solicitation },
  );
}

async function cancelInvoiceDevolutionSolicitation(solicitation) {
  return RestService.postAuthenticated(
    'invoice/devolution/cancel',
    { solicitation },
  );
}

export default {
  getSphereMotivosList,
  getClientContactEmailsList,
  getInvoiceDevolutionList,
  getInvoiceDevolutionDetails,
  uploadInvoiceDevolutionFile,
  deleteInvoiceDevolutionFile,
  sendInvoiceDevolutionSolicitation,
  createInvoiceDevolutionSolicitation,
  cancelInvoiceDevolutionSolicitation,
};
